"use client";

import { useCallback } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useReferralMe } from "@/lib/hooks/useReferralMe";

/**
 * Share URL + partner tools for item cards (Market, home rows, etc.).
 * Admins and market partners see share; partners get referral link in URL when code is ready.
 */
export function useItemShareCard() {
  const { user } = useAuth();
  const origin = typeof window !== "undefined" ? window.location.origin : "";

  const { state: referralState } = useReferralMe(Boolean(user));

  const referralOk = referralState?.kind === "ok";
  const referralCode = referralOk ? referralState.data.code : "";

  const marketPartner = user?.partner_type === "market_partner" || referralOk;

  const showItemShare = Boolean(user && (user.isAdmin || marketPartner));

  const partnerShareToolsEnabled = Boolean(marketPartner && referralCode);

  const buildItemShareUrl = useCallback(
    (itemId: string) => {
      if (!origin) return "";
      if (partnerShareToolsEnabled && referralCode) {
        return `${origin}/item/${itemId}?ref=${encodeURIComponent(referralCode)}`;
      }
      return `${origin}/item/${itemId}`;
    },
    [origin, partnerShareToolsEnabled, referralCode],
  );

  return {
    showItemShare,
    partnerShareToolsEnabled,
    buildItemShareUrl,
  };
}
